( function( global, $ ) {
    "use strict";

    var _events = {
        onChangeCategory: function() {
            var $categoryInput = $(this),
                $formEntry = $categoryInput.closest('[data-form-entry="fee"]'),
                $typeInput = $formEntry.find('[data-form-control="type"]'),
                $valueInput = $formEntry.find('[data-form-control="value"]'),
                $deductibleInput = $formEntry.find('[data-form-control="deductible"]'),
                categoryValue = $categoryInput.val(),
                stampFee = {};

            if (categoryValue === '' || $typeInput.val() !== '' || $valueInput.val() !== '') {
                return;
            }

            if (this.selectize) {
                stampFee = this.selectize.options[categoryValue]['stamp-fee'];
            } else {
                stampFee = $categoryInput.find(':selected').data('data')['stamp-fee'];
            }

            if (stampFee) {
                $typeInput.val(stampFee.type);
                $valueInput.val(stampFee.value);
                $deductibleInput.prop('checked', stampFee.deductible);
            }

            $typeInput.trigger('refresh');
        },

        onChangeType: function() {
            $(this).trigger('refresh');
        },

        onRefreshType: function() {
            var $typeInput = $(this),
                $formEntry = $typeInput.closest('[data-form-entry="fee"]'),
                $valueField = $formEntry.find('[data-form-field="value"]'),
                $valueInput = $formEntry.find('[data-form-control="value"]'),
                $labels = $valueField.find('label[data-label-value]'),
                type = $typeInput.val(),
                value = $valueInput.val(),
                labelType = '';

            $valueField.addClass('hidden');

            if (type !== '') {
                $valueField.removeClass('hidden');

                labelType = type == 1 ? 'percent' : 'fixed';

                if (labelType === 'percent') {
                    $valueInput.attr('max', 100);

                    if (value >= 100) {
                        $valueInput.val('');
                    }
                } else {
                    $valueInput.removeAttr('max');
                }
            }

            $labels.addClass('hidden');
            $labels.filter('[data-label-value="'+labelType+'"]').removeClass('hidden');
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="fee"]'),
            $categoryInputs = $formEntries.find('[data-form-control="category"]'),
            $typeInputs = $formEntries.find('[data-form-control="type"]');

        $categoryInputs.on('change', _events.onChangeCategory);

        $typeInputs
            .on('change', _events.onChangeType)
            .on('refresh', _events.onRefreshType)
            .trigger('refresh');
    });

}( window.groots, jQuery ));
